import config from '../config';

// Function to check if token is expired
export const isTokenExpired = (token) => {
  if (!token) return true;

  try {
    // Decode JWT token (simple base64 decode for payload)
    const payload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Date.now() / 1000;

    // Check if token expires within next 5 minutes (300 seconds)
    return payload.exp < (currentTime + 300);
  } catch (error) {
    return true;
  }
};

// Function to refresh token proactively
export const refreshTokenIfNeeded = async () => {
  const token = localStorage.getItem('token');
  const refreshToken = localStorage.getItem('refresh_token');

  if (!token || !refreshToken) {
    return false;
  }

  if (isTokenExpired(token)) {
    try {
      const response = await fetch(`${config.API_BASE_URL}/auth/refresh`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          refresh_token: refreshToken
        }),
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem('token', data.access_token);
        return true;
      } else {
        // Refresh failed, clear tokens
        localStorage.removeItem('token');
        localStorage.removeItem('refresh_token');
        return false;
      }
    } catch (error) {
      console.error('Token refresh failed:', error);
      localStorage.removeItem('token');
      localStorage.removeItem('refresh_token');
      return false;
    }
  }

  return true;
};